import CodeBlock from "./block-prototype";

export default CodeBlock.extend({
  tagName: "error-block",
  className: CodeBlock.prototype.className + " code-block",
  template: require("templates/block/block-types/error.hbs"),
});
